import { Container, Flex, Heading } from '@radix-ui/themes'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'
import { PluginServiceAPI } from '@API/data-services/plugin-service'
import { DEFAULT_STALE_DATA_TIMEOUT } from '@AppState/app-config/types'
import { PLUGIN_SLOTS } from './types'
import { PluginSection } from './plugin-section'
import './styles.scss'

export const PluginConfiguration = () => {
  const { activeCustomerId } = useSelector((state: RootState) => state.users)

  const { data: definitions } = useQuery({
    queryKey: [`${activeCustomerId}-plugin-definitions`],
    staleTime: DEFAULT_STALE_DATA_TIMEOUT,
    queryFn: async () => {
      return PluginServiceAPI.listDefinitions()
    },
  })

  const { data: mappings, refetch: refetchMappings } = useQuery({
    queryKey: [`${activeCustomerId}-plugin-mappings`],
    staleTime: DEFAULT_STALE_DATA_TIMEOUT,
    queryFn: async () => {
      return PluginServiceAPI.listMappings()
    },
  })

  const findMapping = (type: string, refId?: string) => {
    return mappings?.find((m) => m.type === type && m.refId === refId)
  }

  const filterDefinitions = (type: string) => {
    return definitions?.filter((d) => d.type === type) || []
  }

  return (
    <Container>
      <Flex direction="column" gap="4">
        <Heading>Plugin Configuration</Heading>

        {PLUGIN_SLOTS.map((slot) => {
          const mapping = findMapping(slot.type, slot.refId)
          const slotDefinitions = filterDefinitions(slot.type)

          return (
            <PluginSection
              key={`${slot.type}-${slot.refId || 'default'}`}
              slot={slot}
              mapping={mapping}
              definitions={slotDefinitions}
              onSaved={refetchMappings}
            />
          )
        })}
      </Flex>
    </Container>
  )
}
